module.exports = __webpack_public_path__ + "img/vacunacion.42e75da9.png";